import {useState, useEffect} from 'react'
import {getCities} from '../../services/componentsService'

// Normalize any /cities/ payload to display strings. The backend currently returns joined strings
// ("Miami, United States"); this ALSO tolerates a future structured serializer ({id,name,country})
// by flattening it to the same "Name, Country" display string, so a backend serializer change and
// this frontend can merge in any order without breaking the seven string-based city consumers.
export const normalizeCities = (data: any): string[] => {
  const arr = Array.isArray(data) ? data : Array.isArray(data?.results) ? data.results : []
  return arr
    .map((c: any) => {
      if (typeof c === 'string') return c
      if (c && typeof c === 'object') {
        const name = c.name ?? ''
        const country = c.country ?? ''
        return country ? `${name}, ${country}` : String(name)
      }
      return String(c ?? '')
    })
    .filter((s: string) => s !== '')
}

export const useCitiesField = (search?: string) => {
  const [cities, setCities] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    let isMounted = true

    const fetchCities = async () => {
      try {
        setLoading(true)
        setError(null)
        const term = search?.trim() ? search.trim() : undefined
        const data = await getCities(term)
        if (isMounted) setCities(normalizeCities(data))
      } catch (err) {
        if (isMounted) setError(err as Error)
      } finally {
        if (isMounted) setLoading(false)
      }
    }

    fetchCities()
    return () => {
      isMounted = false
    }
  }, [search])

  return {cities, loading, error}
}
